<template>
    <div :class="{ panelWidget: true, clickableHeader }">
        <div v-if="$slots.header" class="panelHeader" @click="$emit('header-click')">
            <div class="panelHeaderContent">
                <i v-if="icon" :class="['fa', 'headerIcon', icon]"></i>
                <slot name="header"></slot>
            </div>

            <div class="panelHeaderButton" v-if="$slots.headerButton" @click.stop>
                <slot name="headerButton"></slot>
            </div>
        </div>

        <div :class="{ panelBody: true, noPadding }">
            <slot name="body"></slot>
        </div>

        <div class="panelActions" v-if="$slots.actions">
            <slot name="actions"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PanelWidget',

    props: {
        icon: {
            type: String,
            default: ''
        },
        clickableHeader: {
            type: Boolean,
            default: false
        },
        noPadding: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="scss">
@import '../assets/styles/components/widget';

.panelWidget {
    @include widget();

    .panelHeader {
        padding: 0;

        .panelHeaderContent {
            width: 100%;
            padding: 10px 15px;
            display: flex;
            flex-direction: row;
            align-items: baseline;
        }
    }

    &.clickableHeader > .panelHeader:hover {
        cursor: pointer;
        background: lighten($color_gray_white_smoke, 2%);
    }

    .panelHeaderButton {
        button {
            background: transparent;
            border: 0;
            border-left: 1px solid $color_bootstrap_table_border;
            width: 38px;
            height: 38px;
            outline: none;

            &:not([disabled]) {
                &:hover,
                &.active {
                    background: lighten($color_gray_white_smoke, 10);
                }
            }
        }
    }
}
</style>
